














import { defineComponent, onMounted } from '@vue/composition-api';
import { SelfServeSmartInterest } from '@ad/self-serve-sdk-vue';
import { useSmartInterestHook } from './hooks';
import { DRAWER_BODY_CSS, STARLING_KEYS, EXTERNAL_URL_CONFIG, TRACKING_EVENTS } from './const';
import { trackEvent } from './../../tea-tracker';

export default defineComponent({
  name: 'SmartInterestsAndBehaviors',
  components: {
    SelfServeSmartInterest,
  },
  setup() {
    const hookValues = useSmartInterestHook();
    onMounted(() => {
      trackEvent(TRACKING_EVENTS.ADD);
    });
    return {
      ...hookValues,
      DRAWER_BODY_CSS,
      STARLING_KEYS,
      EXTERNAL_URL_CONFIG,
    };
  },
});
